import React from "react"
import styled from "styled-components/macro"
import { PageMargin } from "../../GlobalStyles"
import Nav from "../Nav/Nav"
import colors from "../../scripts/colors"
import HeaderContact from "./HeaderContact"

type PropTypes = {
  info: any
  metaData: any
}

const HeaderStyles = styled.header`
  display: flex;
  height: 60px;
  margin-bottom: -73px;
  position: relative;
  z-index: 1000;
  background-color: ${colors("grey", "dk")};
  @media screen and (min-width: 1024px) {
    background-color: transparent;
    height: 158px;
  }
`

const HeaderPageMargin = styled(PageMargin)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
`

const LogoBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const LogoIconImage = styled.img`
  width: 75px;
  margin-right: 10px;
  margin-top: 7px;
  @media screen and (min-width: 1024px) {
    width: 240px;
    margin-right: 0;
  }
`

const LogoTextImage = styled.img`
  display: none;
  width: 165px;
  margin-top: -15px;
  &#Logo-text--sm {
    display: block;
  }
  &#Logo-text--m {
    display: none;
  }
  &#Logo-text--lg {
    display: none;
  }
  @media screen and (min-width: 1024px) {
    display: block;
    width: 250px;
    margin-top: -75px;
    &#Logo-text--sm {
      display: none;
    }
    &#Logo-text--m {
      display: block;
    }
    &#Logo-text--lg {
      display: none;
    }
  }
  @media screen and (min-width: 1500px) {
    width: 305px;
    &#Logo-text--sm {
      display: none;
    }
    &#Logo-text--m {
      display: none;
    }
    &#Logo-text--lg {
      display: block;
    }
  }
`

const BgBoxWrap = styled.div`
  display: none;
  position: absolute;
  top: 0;
  z-index: -1;
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: block;
  }
`

const BgBoxSmall = styled.div`
  background-color: white;
  position: absolute;
  top: 0;
  height: 86px;
  width: 100%;
`

const BgBoxLarge = styled.div`
  background-color: white;
  position: absolute;
  top: 0;
  right: 0;
  height: 158px;
  @media screen and (min-width: 1024px) {
    width: calc(100% - (((100% - 900px) / 2) + 120px));
    display: block;
  }
  @media screen and (min-width: 1500px) {
    width: calc(100% - (((100% - 1200px) / 2) + 120px));
  }
`

const BgLineWrap = styled.div`
  position: absolute;
  width: 100%;
  z-index: -1;
  @media screen and (min-width: 1024px) {
    z-index: 2000;
  }
  div {
    height: 2px;
    @media screen and (min-width: 1024px) {
      height: 5px;
    }
  }
`

const BgLineLeft = styled.div`
  display: none;
  background-color: ${colors("blue")};
  position: absolute;
  top: 68px;
  left: 0;
  @media screen and (min-width: 1024px) {
    width: calc(((100% - 900px) / 2) + 20px);
    display: block;
  }
  @media screen and (min-width: 1500px) {
    width: calc(((100% - 1200px) / 2) + 20px);
  }
`

const BgLineRight = styled.div`
  background-color: ${colors("grey")};
  position: absolute;
  top: 60px;
  right: 0;
  width: 100%;
  @media screen and (min-width: 1024px) {
    width: calc(100% - ((100% - 900px) / 2) - 185px);
    top: 138px;
  }
  @media screen and (min-width: 1500px) {
    width: calc(100% - ((100% - 1200px) / 2) - 185px);
    top: 138px;
  }
`

const HomeHeader: React.FC<PropTypes> = ({ info, metaData }) => {
  return (
    <HeaderStyles id="Site-header" role="banner">
      <BgBoxWrap>
        <BgBoxSmall></BgBoxSmall>
        <BgBoxLarge></BgBoxLarge>
      </BgBoxWrap>
      <BgLineWrap>
        <BgLineLeft className="BgLine"></BgLineLeft>
        <BgLineRight className="BgLine"></BgLineRight>
      </BgLineWrap>
      <HeaderPageMargin>
        <LogoBox>
          <LogoIconImage
            loading="lazy"
            src={`https://res.cloudinary.com/agoraservices/w_240,q_auto,f_auto/${metaData.logoIconImageId}`}
            alt={`${info.facilityName} logo icon`}
          />
          <LogoTextImage
            loading="lazy"
            id="Logo-text--lg"
            src={`https://res.cloudinary.com/agoraservices/w_305,q_auto,f_auto/${metaData.logoTextImageId}`}
            alt={`${info.facilityName} logo text`}
          />
          <LogoTextImage
            loading="lazy"
            id="Logo-text--m"
            src={`https://res.cloudinary.com/agoraservices/w_250,q_auto,f_auto/${metaData.logoTextImageId}`}
            alt={`${info.facilityName} logo text`}
          />
          <LogoTextImage
            loading="lazy"
            id="Logo-text--sm"
            src={`https://res.cloudinary.com/agoraservices/w_165,q_auto,f_auto,co_rgb:${colors(
              "grey",
              "xlt",
              1,
              true
            )},e_colorize:100/${metaData.logoTextImageId}`}
            alt={`${info.facilityName} logo text`}
          />
        </LogoBox>
        <HeaderContact className="HeaderContact--desktop" info={info} />
        <Nav
          headerType="home"
          id="Nav--desktop"
          className="Site-nav"
          currLocation="/"
        />
      </HeaderPageMargin>
    </HeaderStyles>
  )
}

export default HomeHeader
